import React from 'react';
import {
    VideoSource,
    VideoMetadata,
    VideoPlayerConfig,
    VideoPlayerEvents,
    VideoSourceType,
    VideoQuality,
} from '@/interfaces/video';
import { messages } from './messages';
import { resolvePath } from '@/utils/resolvePath';
import { VIDEO_THUMBNAIL_CONFIG, BASE_VIDEO_CONFIG } from './config';

export const createVideoSource = (videoUrl: string): VideoSource => {
    return {
        id: messages.videoId,
        type: VideoSourceType.S3_DIRECT,
        url: videoUrl,
        quality: VideoQuality.AUTO,
        locked: false,
    };
};

export const createVideoMetadata = (): VideoMetadata => {
    return {
        title: messages.videoTitle,
        thumbnail: resolvePath(VIDEO_THUMBNAIL_CONFIG.thumbnailPath),
        thumbnailWidth: VIDEO_THUMBNAIL_CONFIG.thumbnailWidth,
        thumbnailHeight: VIDEO_THUMBNAIL_CONFIG.thumbnailHeight,
    };
};

export const createVideoConfig = (shouldPlay: boolean): VideoPlayerConfig => {
    return {
        ...BASE_VIDEO_CONFIG,
        autoplay: shouldPlay,
    };
};

export const createVideoEvents = (
    setShouldPlay: (value: boolean) => void
): VideoPlayerEvents => {
    return {
        onPlay: () => {
            setShouldPlay(true);
        },
        onPause: () => {
            setShouldPlay(false);
        },
    };
};

export const handleVideoContainerClick = (
    videoUrl: string | null,
    containerRef: React.RefObject<HTMLDivElement>
): void => {
    if (videoUrl && containerRef.current) {
        const videoElement = containerRef.current.querySelector('video');
        if (videoElement) {
            if (videoElement.paused) {
                videoElement.play().catch((error) => {
                    console.warn('Error playing video:', error);
                });
            } else {
                videoElement.pause();
            }
        }
    }
};
